module.exports = __webpack_public_path__ + "static/media/sample_lmapprovedsob.0fc2c1a9.csv";